<template>
    <sweet-modal
      modal-theme="light"
      overlay-theme="dark"
      ref="modal"
      width="1200"
      :hide-close-button="true"
      :blocking="true"
    >
    <template slot="title">
      <h4 class="my-3">Invoice # {{ invoice.id }} for {{ invoice.client.name }}</h4>
    </template>
    <template slot="box-action">
        <a class="btn btn-sm btn-dark mr-2" target="_blank" :href="invoiceUrl(invoice.id)"><i class="fa fa-file-invoice"></i> Print</a>
        <!-- <button class="btn btn-sm btn-dark mr-2" @click="save"><i class="fa fa-save"></i> Save</button> -->
        <button class="btn btn-sm btn-dark mr-2" @click="$router.push('/invoices')"><i class="fa fa-times"></i> Cancel</button>
    </template>
    <div class="row">
      <div class="col-6">
        <h6>BILL TO</h6>
        {{ invoice.client.name }}
      </div>
      <div class="col-6">
        <table class="table m-4 border-bottom">
          <tbody>
            <tr>
              <td>INVOICE #</td>
              <td>{{ invoice.id }}</td>
            </tr>
            <tr>
              <td>DATE</td>
              <td>{{ date(invoice.created_at) }}</td>
            </tr>
            <tr>
              <td>STATUS</td>
              <td>Draft</td>
            </tr>
          </tbody>
        </table> 
      </div>
    </div>
    <div style="min-height: 400px;">
      <table class="table">
        <thead>
          <tr>
            <th>LINE</th>
            <th>NAME</th>
            <th>COST</th>
            <th>QTY</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in invoice.items"
            :key="item.id"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.cost }}</td>
            <td>{{ item.qty }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="text-right"><strong>TOTAL</strong></td>
            <td>{{ invoice.total }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div>
      <textarea placeholder="Notes printed on invoice" class="form-control"></textarea>
    </div>
    </sweet-modal>
</template>

<script>

import moment from 'moment'
// import n from '@/libs/notifications'
import api from '@/api'
import { SweetModal } from 'sweet-modal-vue'

export default {
  name: 'tranport-detail',
  components: {
    SweetModal,
  },

  props: {
    id: Number
  },

  data() {
    return {
      invoice: { item:[], client: {}}
    }
  },

  watch: {
    id() {
      this.fetchData()
    }
  },

  methods: {
    invoiceUrl(id) {
      return `${api.baseUrl}/invoices/${id}/invoice`
    },

    date(date) {
      return moment(date).format('l')
    },

    fetchData() {
      if (this.id) {
        api.get(`/invoices/${this.id}`).then(res => {
          this.invoice = res.data.invoice
        })
      }
    },

    save() {
      // api.post(`/invoices/${this.invoice.id}`, { order: {
      //     notes: this.invoice .notes,
      //     bol_notes: this.invoice .bol_notes,
      //     appointment_at: this.invoice.appointment_at,
      //     total_qty: this.invoice.total_qty,
      //     units: this.invoice.units,
      //     cargo: this.invoice.cargo,
      //   }}).then(() => {
      //   n.success('invoice Save')
      // }).catch(err => {
      //   n.error(`There was an error: ${err}`)
      // })
    }
  }
}
</script>

<style scoped>


</style>